export default __webpack_public_path__ + "images/0xe55e19fb4f2d85af758950957714292dac1e25b2.png";